import PropTypes from 'prop-types';
import React from 'react';
import FlexRow from '../../../common/components/layout/FlexRow';
import DownloadInvoice from './DownloadInvoice';
import InvoiceOnStripe from './InvoiceOnStripe';
import {INVOICE_STATUS} from '../../../common/constants';
import HostedInvoiceUrl from './HostedStripeInvoice';

const RowActionInvoicesAdmin = ({invoice}) => {
  return (
    <FlexRow>
      {invoice.status !== INVOICE_STATUS.DRAFT && (
        <>
          <DownloadInvoice invoicePdf={invoice.invoicePdf}/>
          <HostedInvoiceUrl hostedInvoiceUrl={invoice.hostedInvoiceUrl}/>
        </>
      )}
      <InvoiceOnStripe invoiceUrl={invoice.adminStripeUrl}/>
    </FlexRow>
  );
};

RowActionInvoicesAdmin.propTypes = {
  invoice: PropTypes.shape({
    adminStripeUrl: PropTypes.string.isRequired,
    invoicePdf: PropTypes.string,
    status: PropTypes.string.isRequired,
  }),
};

export default (RowActionInvoicesAdmin);
